/**
 * 客服聊天相关路由配置
 */
const chatRoutes = [
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/chat/ChatView.vue'),
    meta: {
      title: '客服',
      requireAuth: true,
      hideNav: true
    }
  }
]

export default chatRoutes
